module.exports = __webpack_public_path__ + "media/A1.6d71c64b.mp3";